import { FC, useEffect, useState } from "react";
import "./Devices.scss";
import MainNavbar from "../../../components/MainNavbar/MainNavbar";
import ProfileLayout from "../../../components/ProfileLayout/ProfileLayout";
import { useAuth } from "../../../providers/AuthProvider";
import { BvIcon } from "bevi-icon";
import Swal from "sweetalert2";
import { renderToStaticMarkup } from "react-dom/server";
import { ProfileService } from "../../../services/Profile/ProfileService";

interface DeviceRow {
  user_id: number;
  partner_code: string;
  name: string;
  operating_system: string;
  browser: string;
  location: string;
  last_session: string;
  is_active: boolean;
}

const profileService = new ProfileService();

const Devices: FC = () => {
  const { profileImageUrl } = useAuth();
  const [devices, setDevices] = useState<DeviceRow[]>([]);

  useEffect(() => {
    profileService.getActiveSessions().then((res: any) => {
      setDevices(res[0]?.data?.users ?? []);
    });
  }, []);

  const handleRevokeSession = (userId: number) => {
    Swal.fire({
      title: "Finalizar sessão",
      text: "Deseja encerrar o acesso deste dispositivo?",
      iconHtml: renderToStaticMarkup(<BvIcon name="warning" variant="solid" width={106} height={106} style={{color:"#787ABA"}} />),
      showCancelButton: true,
      confirmButtonColor: "#222343",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Sim, finalizar",
      cancelButtonText: "Cancelar",
      customClass: {
        title: "swal-title",
        htmlContainer: "swal-text",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        profileService.revokeSession(userId).then(() => {
          const now = new Date().toLocaleString("pt-BR");
          setDevices((prev) =>
            prev.map((d) => d.user_id === userId ? { ...d, last_session: now } : d)
          );
        });
      }
    });
  };

  return (
    <>
      <MainNavbar />
      <div className="Devices" data-testid="Devices">
        <div className="devices-card">
          <ProfileLayout profileImageUrl={profileImageUrl}>
            <div className="devices-content-inner">
              <h5 className="mb-2 devices-title">Sessões e Dispositivos</h5>
              <p className="devices-subtitle">
                Por motivos de segurança, cada conta está limitada a um dispositivo conectado.
              </p>

              <div className="devices-table-wrapper">
                {devices.filter(device => device != null).length === 0 ? (
                  <p style={{ color: "#6c757d" }}>
                    Nenhum dispositivo conectado
                  </p>
                ) : (
                  <table className="devices-table">
                    <thead>
                      <tr>
                        <th>Usuário</th>
                        <th>Sistema</th>
                        <th>Navegador</th>
                        <th>Localização</th>
                        <th>Última Sessão</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {devices.filter(device => device != null).map((device, index) => (
                        <tr key={device.user_id ?? index}>
                          <td style={{ verticalAlign: "top" }}>
                            <span style={{ display: "block", fontSize: "10px" }}>{device.partner_code}</span>
                            <span style={{ fontSize: "12px" }}>{device.name}</span>
                          </td>
                          <td style={{ paddingTop: "30px" }}>{device.operating_system}</td>
                          <td style={{ paddingTop: "30px" }}>{device.browser?.split(".")[0]}</td>
                          <td style={{ paddingTop: "30px" }}>{device.location}</td>
                          <td style={{ paddingTop: "30px" }}>{device.last_session === "Este dispositivo" ? "Online" : device.last_session}</td>
                          <td style={{ paddingTop: "30px" }}>
                            {device.last_session === "Este dispositivo" ? (
                              <button className="devices-delete-btn" title="Deslogar dispositivo" onClick={() => handleRevokeSession(device.user_id)}>
                                <BvIcon name="trashDelete" variant="solid" width={14} height={16} />
                              </button>
                            ) : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </ProfileLayout>
        </div>
      </div>
    </>
  );
};

export default Devices;
